import { FIELD, fieldBorder } from './UI';

/** One distinction shared by manual entry and both import-review flows. */
export function TransportPurposeField({ mode, isRental, onChange }: {
  mode?: string; isRental?: boolean; onChange: (value: boolean) => void;
}) {
  if (mode !== 'Car') return null;
  return <label className="block space-y-1.5">
    <span className="ds-label block">Car booking type</span>
    <select value={isRental ? 'rental' : 'journey'} onChange={e => onChange(e.target.value === 'rental')}
      className={`${FIELD} ${fieldBorder(false)}`}>
      <option value="journey">Journey / transfer</option>
      <option value="rental">Car hire · pickup and return</option>
    </select>
    <span className="block text-sm text-app-sub">Car hire appears within destination cards, not between them.</span>
  </label>;
}
